import React from "react";

// Margins are logical so the full-bleed -16px offset lands on the reading-start side in RTL too
const MobileSectionSeperator = ({ order, marginBlock, marginInline, className }) => {
  return (
    <div
      className={`mobileSectionSeperator ${className ?? ""}`}
      style={{ order: order ?? "", marginBlock, marginInline }}
    ></div>
  );
};

export default MobileSectionSeperator;
